import React from 'react';
import { useTranslation } from 'react-i18next';
import { EReaderIcon, TabletIcon, CompressIcon } from './Icons';

const ConversionOptions = ({ options, onOptionsChange }) => {
  const { t } = useTranslation();
  
  const handleChange = (key, value) => {
    const newOptions = { ...options, [key]: value };
    onOptionsChange(newOptions);
  };

  return (
    <div className="card">
      <div className="card-content">
        <h3>⚙️ {t('conversion.title')}</h3>
        
        {/* Quick Presets - Highlighted Section */}
        <div className="option-group highlight">
          <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <h4 style={{ marginBottom: '12px', color: '#2196f3', fontSize: '16px', fontWeight: '600' }}>{t('conversion.presets')}</h4>
            <div className="preset-buttons">
              <button
                className="preset-btn"
                onClick={() => onOptionsChange({
                  imageQuality: 0.8,
                  maxWidth: 1200,
                  maxHeight: 1600,
                  optimizeImages: true,
                  compressionLevel: 6
                })}
              >
                <EReaderIcon size={16} />
                E-Reader
              </button>
              <button
                className="preset-btn"
                onClick={() => onOptionsChange({
                  imageQuality: 0.9,
                  maxWidth: 1600,
                  maxHeight: 2400,
                  optimizeImages: true,
                  compressionLevel: 6
                })}
              >
                <TabletIcon size={16} />
                Tablet
              </button>
              <button
                className="preset-btn"
                onClick={() => onOptionsChange({
                  imageQuality: 0.6,
                  maxWidth: 800,
                  maxHeight: 1200,
                  optimizeImages: true,
                  compressionLevel: 9
                })}
              >
                <CompressIcon size={16} />
                Small Size
              </button>
            </div>
          </div>
        </div>

        {/* Advanced Options - More Compact */}
        <div style={{ marginTop: '8px' }}>
          <h4 style={{ marginBottom: '12px', color: '#757575', fontSize: '14px', fontWeight: '500' }}>{t('conversion.advanced')}</h4>
          
          {/* Max Width and Max Height in one row */}
          <div className="option-row">
            <div className="option-group compact half-width">
              <label htmlFor="maxWidth">{t('conversion.maxWidth')}:</label>
              <input
                type="number"
                id="maxWidth"
                min="100"
                max="4000"
                value={options.maxWidth}
                onChange={(e) => handleChange('maxWidth', parseInt(e.target.value))}
              />
            </div>
            <div className="option-group compact half-width">
              <label htmlFor="maxHeight">{t('conversion.maxHeight')}:</label>
              <input
                type="number"
                id="maxHeight"
                min="100"
                max="4000"
                value={options.maxHeight}
                onChange={(e) => handleChange('maxHeight', parseInt(e.target.value))}
              />
            </div>
          </div>

          {/* Quality and Compression in one row */}
          <div className="option-row">
            <div className="option-group compact half-width">
              <label htmlFor="imageQuality">{t('conversion.quality')}:</label>
              <input
                type="range"
                id="imageQuality"
                min="0.1"
                max="1.0"
                step="0.1"
                value={options.imageQuality}
                onChange={(e) => handleChange('imageQuality', parseFloat(e.target.value))}
              />
              <span>{options.imageQuality}</span>
            </div>
            <div className="option-group compact half-width">
              <label htmlFor="compressionLevel">{t('conversion.compression')}:</label>
              <input
                type="range"
                id="compressionLevel"
                min="0"
                max="9"
                value={options.compressionLevel}
                onChange={(e) => handleChange('compressionLevel', parseInt(e.target.value))}
              />
              <span>{options.compressionLevel}</span>
            </div>
          </div>

          <div className="option-group compact">
            <label htmlFor="optimizeImages">{t('conversion.optimizeImages')}:</label>
            <input
              type="checkbox"
              id="optimizeImages"
              checked={options.optimizeImages}
              onChange={(e) => handleChange('optimizeImages', e.target.checked)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConversionOptions;
